
/* User defined models */
import { Test } from "./test.model";
import { Client } from "./client.model";

export class Booking {
    id: string;
    number?: string;
    href: string;
    candidate: any;  
    tests: Test[];
    payments: any[];
    testingAccommodations: any[];
    hold: any;
    client?: Client;
}